import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" })
});
export default SvgGoogle;
